import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  section: (background?: string) => ({
    background,
    p: ['40px 0 48px', '40px 0 48px', '64px 0', '64px 0', '88px 0'],
    display: 'flex',
    justifyContent: ['space-around', 'space-around', 'space-around', 'space-around', 'space-between'],
    alignItems: 'center',
    flexWrap: ['wrap', 'wrap', 'wrap', 'wrap', 'nowrap'],
    position: 'relative',
    zIndex: theme.zIndex.documentUp + 1,
    minHeight: ['auto', 'auto', 'auto', 'auto', '48.8888889vw', '46.875vw']
  }),
  descriptionStyles: {
    maxWidth: ['100%', '100%', '100%', '100%', '20.9375vw'],
    width: '100%',
    textAlign: ['center', 'center', 'center', 'center', 'left'],
    ml: ['0', '0', '0', '0', '80px'],
    padding: 0,
    svg: {
      display: ['none', 'none', 'none', 'none', 'inline-flex'],
      transform: 'rotate(180deg)',
      ...reusables.mainTransition('color', theme.transitions.animation.atomCurve, theme.transitions.time.normal)
    },
    'p, h1': {
      p: ['0 40px 40px', '0 40px 40px', '0px 64px 64px', '0px 64px 64px', '0 0 40px'],
      fontSize: 16,
      width: ['100%', '100%', '100%', '100%', '14.4444444vw', '12.6041667vw'],
      maxWidth: ['100%', '100%', '100%', '100%', '210px'],
      textTransform: 'none',
      fontFamily: theme.fonts.uniform,
      fontWeight: theme.fontWeights.normal,
      letterSpacing: 0,
      lineHeight: '140%'
    },
    'h1, h2': {
      pb: '16px'
    }
  }
};